import { subCasteListApi } from "../../api/subCaste/subCasteListApi"
import { SubCaste } from "../../entities/subCaste"

type PayloadShape = Parameters<typeof subCasteListApi>[0]

export async function subCasteListService(payload: PayloadShape, token?: null | string) {
	const subCaste = await subCasteListApi(payload, token)
	return subCaste as NonNullable<SubCaste[]>
}
